// Разбор вердикта для ПОКАЗА — одним местом. Точек, которым нужно «оценён ли
// ответ и как», три (палитра варианта, поле/карточка, авторский фидбэк), и
// каждая раньше разбирала вердикт сама сравнением строк: новый вариант
// `Verdict` уехал бы у них в ветку «неправильно» молча.
import { exhaustive } from './exhaustive'
import type { Verdict } from './verdict'

/** `ungraded` — оценки нет: ответ ещё не проверен ИЛИ проверять нечем. */
export type VerdictGrade = 'ungraded' | 'correct' | 'incorrect'

export const verdictGrade = (verdict: Verdict | null): VerdictGrade => {
  if (verdict === null) return 'ungraded'
  switch (verdict) {
    case 'correct':
      return 'correct'
    case 'incorrect':
      return 'incorrect'
    case 'accepted':
      return 'ungraded'
    default:
      return exhaustive(verdict, 'ungraded')
  }
}
